import React, { useEffect, useRef, useState } from 'react'
import { makeAjax, respStatus, url, showMessage } from '../../../../helpers/global_helper';
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { formatPricewithdecimal } from "../../../NumberFormat";
import ConfirmBetDeskonPopup from '../../../Popups/ConfirmBetDeskonPopup';
import { BetProperSet } from './BetProperSet';
import BetSuccessPopup from '../../../Popups/BetSuccessPopup';
import { getUserBalance, setCommonConfig } from '../../../../redux/actions';
import ErrorInnerPopup from '../../../Popups/ErrorInnerPopup';
import ErrorPopup from '../../../Popups/ErrorPopup';
import CancelledBetDeskonPopup from '../../../Popups/CancelledBetDeskonPopup';
import { ReBetCalculate } from './ReBetCalculate';
const ReBetPopup = (props) => {
    const { status, bettype, date, gameid, limitId, period, transId, betTypeId, marketNameId, setPeriod, setReBetShowPopup, setRespData, setSuccessPopup, setBetGameId, setBetDetailIncompletePopup, setSuccess5050Popup, setBetPopupValue, popRef, setSubmitPopup } = props;
    const dispatch = useDispatch();
    const [transectionDetailData, setTransectionDetailsData] = useState([]);
    const [transactionLabel, setTransectionLabel] = useState("");
    const [getGameType, setGameType] = useState("");
    const [gameCode, setGameCode] = useState('');
    const [marketName, setMarketName] = useState('');
    const [totalBuyers, setTotalBuyers] = useState(0);
    const [infoBetType, setInfoBetType] = useState({});
    const [betRowIndex, setBetRowIndex] = useState({})
    const [checkedBoxes, setCheckedBoxes] = useState([])
    const [checkedBoxAll, setCheckedBoxAll] = useState(true)
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [showCancelledPopup, setShowCancelledPopup] = useState(false);
    const [succMessage, setSuccessMessage] = useState("");
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [showErrorMarketPopup, setShowErrorMarketPopup] = useState(false);
    const [errMessage, setErrorMessage] = useState("");
    const [getApiExtention, setApiExtention] = useState("");
    const [betAngaka, setBetAngaka] = useState([])
    const [betAmountPay, setBetAmountPay] = useState([])
    const [getWinAmountPay, setWinAmountPay] = useState([])
    const [reqData, setReqData] = useState({})
    const [showGameClose, setShowGameClose] = useState(false);
    const device = useSelector(state => state.CommonConfig.device_type);
    const userBalance = useSelector((state) => state.UserBalance.user_balance);
    const [betDicountData, setBetDicountData] = useState([])
    const [shioData, setShioData] = useState({})

    const gameTypeData = {
        "6D/5D"                     : "5D6D",
        "4D/3D/2D"                  : "4d3d2d",
        "Colok Bebas"               : "colokbebas",
        "Colok Bebas 2D"            : "colokbebas2d",
        "Colok Jitu"                : "colokjitu",
        "Colok Naga"                : "coloknaga",
        "50-50"                     : "5050",
        "50-50 2D"                  : "50502d",
        "Shio"                      : "shio",
        "Dasar"                     : "dasar",
        "Tengah Tepi"               : "tengahtepi",
        "Kombinasi"                 : "kombinasi",
        "Kembang / Kempis / Kembar" : "kembangkempis",
        "Silang / Homo"             : "silanghomo",
    }

    const hideCommonToaster = () => {
        const commonToaster = document.getElementById("commonToaster");
        if (commonToaster) {
        commonToaster.style.display = "none";
        }
    };

    // api for Transection History Detail
    const featchTransectionHistoryDetail = async () => {
        let isProcess = false;
        let getTransaction = true
        let reqData = {
        act: status,
        bettype: bettype,
        date: date.split(' ')[0],
        game_id: gameid,
        limitid: limitId,
        period: parseInt(period),
        trans_id: transId,
        type: 'winlose'

        };
        const data = await makeAjax(url.TOGEL_API.getGameStatus, {gameId:gameid, betTypeId:betTypeId})
        if(data.data.market_status == 0) {
            isProcess = false
            setErrorMessage(props.t(`${marketNameId[gameid]} market is currently closed`));
            setShowErrorMarketPopup(true);
            return false;
        }
        else {
            setShioData(data.data.Shio)
            isProcess = true
        }
        

        if(isProcess) {
            const response = await makeAjax(url.PLAYER_API.getTransaction, reqData, url.PLAYER_MS_EXT)
            if (response.status != respStatus["SUCCESS"]) {
                getTransaction = false
                if (response.code != "validation_error") {
                showMessage(response);
                return;
                }
                showMessage(response);
                return;
            }
            let getGameMarket = gameTypeData[response.data.label] ? gameTypeData[response.data.label] : "quickbuy";
            if(getTransaction && response) {
                const prizeData = await makeAjax(url.TOGEL_API.getTogelDetails, {gameId:gameid, gameType:getGameMarket});
                setBetDicountData(prizeData.data);

                let payAmounCal = []
                let winAmountPay = []
                response.data.result.map((val, ind) => {
                    let betArray = ReBetCalculate(val.info, response.data.label, bettype, val.posisi, val.amount, val.bet, prizeData.data, val.bet2, val.bet3, shioData)
                    payAmounCal.push(parseFloat(betArray[0]))
                    winAmountPay.push(parseFloat(betArray[1]))
                    setBetAmountPay(payAmounCal)
                    setWinAmountPay(winAmountPay)
                })
            }
            setTransectionDetailsData(response.data.result ? response.data.result : response.data);
            setTransectionLabel(response.data.label)
            setGameType(getGameMarket);
            setMarketName(response.data.game.game_name);
            
            
            setGameCode(response.data.game.game_code)
            setInfoBetType(response.data.infoBetType);
            
            // Calculate total buyers
            if (response.data.result) {
                const total = response.data.result.reduce((accumulator, currentValue) => {
                return accumulator + parseFloat(currentValue.bayar);
                }, 0);
                setTotalBuyers(total.toFixed(2));
            }
        }
    };

    useEffect(() => {
        transectionDetailData.map((value, index) => (
            setBetRowIndex(prev => {
                const newRowIndex = {...prev}
                newRowIndex[index] = index
                return newRowIndex
            }),
            setCheckedBoxes(prevCheck => {
                const newRowIndex = [...prevCheck]
                newRowIndex[index] = true
                return newRowIndex
            })
        ))
    }, [transectionDetailData])

    const handleSelectOption = (e, count, ind) => {
        if(e.target.checked) {
            if(count == 'row') {
                setBetRowIndex(prev => {
                    const newRowIndex = {...prev}
                    newRowIndex[ind] = ind
                    return newRowIndex
                })
                setCheckedBoxes(preCheck => {
                    const newPrevCheck = [...preCheck]
                    newPrevCheck[ind] = e.target.checked
                    return newPrevCheck
                })
            }
            else {
                setCheckedBoxAll(e.target.checked)
                transectionDetailData.map((value, index) => (
                    setBetRowIndex(prev => {
                        const newRowIndex = {...prev}
                        newRowIndex[index] = index
                        return newRowIndex
                    }),
                    setCheckedBoxes(prevCheck => {
                        const newRowIndex = [...prevCheck]
                        newRowIndex[index] = true
                        return newRowIndex
                    })
                ))
            }
        }
        else {
            if(count == 'row') {
                setBetRowIndex(prev => {
                    const newRowIndex = {...prev}
                    delete newRowIndex[ind]
                    return newRowIndex
                })
                setCheckedBoxes(preCheck => {
                    const newPrevCheck = [...preCheck]
                    newPrevCheck[ind] = e.target.checked
                    return newPrevCheck
                })
            }
            else {
                setCheckedBoxAll(e.target.checked)
                setBetRowIndex({})
                transectionDetailData.map((value, index) => (
                    setCheckedBoxes(prevCheck => {
                        const newRowIndex = [...prevCheck]
                        newRowIndex[index] = false
                        return newRowIndex
                    })
                ))
            }
        }
    }

    useEffect(() => {
        let payAmounCal = []
        transectionDetailData.map((val, ind) => {
            if(Object.values(betRowIndex).includes(ind)) {
                payAmounCal.push(parseFloat(betAmountPay[ind]))
            }
            setTotalBuyers(payAmounCal.reduce((accumulator, currentValue) => accumulator + currentValue, 0))
        })
    }, [betRowIndex])

    const submitProcess = () => {
        let betAngakas = [];
        transectionDetailData.map((val, ind) => {
            if(Object.values(betRowIndex).includes(ind)) {                
                let betArray = BetProperSet(transectionDetailData[ind].info, transectionDetailData[ind].amount, transectionDetailData[ind].bet, transectionDetailData[ind].bet2, transectionDetailData[ind].bet3, transactionLabel, transectionDetailData[ind].posisi, shioData, bettype)
                betAngakas.push(betArray)
            }
            setBetAngaka(betAngakas)
        })
        setSuccessMessage(`Process Re-Bet ${marketName}-${setPeriod}`)
        setShowConfirmationPopup(true)
    }

    useEffect(() => {
        console.log("transactionLabel ==>", transactionLabel);
        
        let apiExtention = ''
        let gametype = getGameType
        let action = "process"
        let betTogelAuth = "betTogelAuth"
        let allowPartner = null
        let isfullbet = null
        let game_id = gameid
        let dfp = null
        if(transactionLabel === "4D/3D/2D") {
            if(betTypeId > 1000) {
                dfp = 'fullbet'
            }
            if(betTypeId > 2000) {
                dfp = 'prize123'
            }
            apiExtention = url.TOGEL_API.process4D3D2D
            allowPartner = 'allowPartner'
        }
        else if(transactionLabel === "50-50" || transactionLabel === "50-50 2D") {
            apiExtention = url.TOGEL_API.process5050Shio
        } else if(transactionLabel === "6D/5D") {
            if(betTypeId > 1000) {
                dfp = 'fullbet'
            }
            if(betTypeId > 2000) {
                dfp = 'prize123'
            }
            apiExtention = url.TOGEL_API.process5D6D
            allowPartner = 'allowPartner'
        }
        else if(transactionLabel === "Silang / Homo" || transactionLabel === "Kembang / Kempis / Kembar") {
            allowPartner = 'allowPartner'
            apiExtention = url.TOGEL_API.processAltTogel
        }
        else {
            if(transactionLabel === undefined && betTypeId === 222) {
                apiExtention = url.TOGEL_API.processQuickBuy
                gametype = "quickbuy"
                action = "save"
                allowPartner = 'allowPartner'
            }
            else {
                apiExtention = url.TOGEL_API.processAltTogel
            }
        }
        setReqData({
            gameType : gametype,
            action : action,
            betTogelAuth: betTogelAuth,
            allowPartner : allowPartner,
            gameId : game_id,
            isfullbet : isfullbet,
            dataangka : betAngaka,
            dfp : dfp
        })
        setApiExtention(apiExtention)

        // popRef.current.scrollIntoView({
        //     behavior: "smooth",
        //     block: "start",
        // });
    }, [betAngaka, getGameType])

    const hanldeConfirmationPopupClose = () => {
        setSuccessPopup(false);
        setShowConfirmationPopup(false)
        setShowCancelledPopup(true);
    }
  
    const submitProcessOk = async () => {
        setShowConfirmationPopup(false)
        const processApiResponse = async (requestData) => {
            try {
                const response = await makeAjax(
                getApiExtention,
                requestData
                );
                if (response.status !== respStatus["SUCCESS"]) {
                    if (response.code === "sub_game_status_close") {
                        setShowGameClose(true);
                        showMessage(false);
                        hideCommonToaster();
                        dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
                        return;
                    }
                    if (response.code === "market_close_err") {
                        setErrorMessage(props.t(`${marketName} market is currently closed`));
                        setShowErrorPopup(true);
                        return false;
                    }
                    if (response.code !== "validation_error") {
                        response.code
                        ? setErrorMessage(props.t(response.code))
                        : showMessage(
                            props.t("guess_bet_wrong_place"),
                            "error",
                            "error"
                        );
                        setShowErrorPopup(true);
                        return false;
                    }
                    showMessage("server error No data find", "error", "error");
                    return false;
                }
                if(transactionLabel === "Silang / Homo" || transactionLabel === "Kembang / Kempis / Kembar") {
                    setRespData(response.data);
                }
                else {
                    setRespData((prevArray) => [...prevArray, response.data]);
                }
                setBetGameId(gameid)
                return true;
            } catch (error) {
                showMessage(
                "An error occurred while processing the request",
                "error",
                "error"
                );
                return false;
            }
        };

        let isSuccess = true;
        if(betAngaka.length > 0) {
            if(totalBuyers > userBalance.coin) {
                isSuccess = false;
                setErrorMessage(props.t("insufficiant_balance_err"));
                setShowErrorPopup(true);
                return
            }
            else {
                isSuccess = await processApiResponse(reqData);
                if(isSuccess) {
                    if(betTypeId === 222) {
                        setBetDetailIncompletePopup(true)
                    }
                    else {
                        if(transactionLabel === "50-50" || transactionLabel === "50-50 2D") {
                            setSuccess5050Popup(true)
                        }
                        else if(transactionLabel === "Silang / Homo" || transactionLabel === "Kembang / Kempis / Kembar") {
                            setSubmitPopup(true)
                        }
                        else {
                            setSuccessPopup(true);
                        }
                    }
                }
                dispatch(getUserBalance());
            }
        }
        else {
            isSuccess = false;
            setErrorMessage(props.t("guess_bet_wrong"));
            setShowErrorPopup(true);
            return
        }

        if (isSuccess) {
            setReBetShowPopup(false)
            allDataReset()
        }
    }

    const allDataReset = () => {
        setApiExtention("")
        setReqData({})
        setBetAngaka([])
        setTransectionLabel("")
        setBetRowIndex({})
    }

    useEffect(() => {
        featchTransectionHistoryDetail();
    }, []);
    
    return (
        <div className='trasaction_popup'>
        {/* table */}
        <div className="informasi_tble_result">
            {device === "Desktop" ?
            <table >
                <thead>
                <tr>
                    <th>
                        <input
                            type="checkbox"
                            checked={checkedBoxAll}
                            onClick={(e) => handleSelectOption(e, 'all')}
                        />
                        &nbsp;
                        {props.t("all")}
                    </th>
                    <th>{props.t("bet")}</th>
                    {
                    (infoBetType.BET_TYPE_COLOKBEBAS2D === bettype ||
                        infoBetType.BET_TYPE_COLOKNAGA === bettype ||
                        infoBetType.BET_TYPE_KOMBINASI === bettype ||
                        infoBetType.BET_TYPE_QUICKBUY === bettype ||
                        infoBetType.BET_TYPE_MACAU_SHIO === bettype) &&
                    <th>{props.t("bet")}2</th>
                    }
                    {
                    (
                        infoBetType.BET_TYPE_QUICKBUY === bettype ||
                        infoBetType.BET_TYPE_COLOKNAGA === bettype) &&
                    <th>{props.t("bet")}3</th>
                    }
                    {
                    (
                        infoBetType.BET_TYPE_QUICKBUY === bettype ||
                        infoBetType.BET_TYPE_COLOKJITU === bettype) &&
                    <th>{props.t("position")}</th>
                    }
                    <th>{props.t("amount")}</th>
                    <th>{props.t("discount")} %</th>
                    <th>
                    {infoBetType.BET_TYPE_5050 === bettype ||
                        infoBetType.BET_TYPE_50502D === bettype ||
                        infoBetType.BET_TYPE_TENGAHTEPI === bettype ||
                        infoBetType.BET_TYPE_DASAR === bettype ||
                        infoBetType.BET_TYPE_SILANGHOMO === bettype ||
                        infoBetType.BET_TYPE_KEMBANGKEMPIS === bettype ? `${props.t("kei")} %` : props.t("prize")
                    }
                    </th>
                    <th>{props.t("total_amount")}</th>
                    <th>{props.t("x_win")}</th>
                    <th>{props.t("description")}</th>
                </tr>
                </thead>
                <tbody>
                {transectionDetailData.length === undefined ? (
                    <tr className='table_data_empty_row'>
                    <td colSpan="8">{props.t("data_not_found")}</td>
                    </tr>
                ) : (
                    transectionDetailData.map((value, index) => (

                    <tr
                        key={index}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                        <td>
                            <input
                                type="checkbox"
                                checked={checkedBoxes[index]}
                                onClick={(e) => handleSelectOption(e, 'row', index)}
                            />
                        </td>
                        <td>{value.bet}</td>
                        {
                        (infoBetType.BET_TYPE_COLOKBEBAS2D === bettype ||
                            infoBetType.BET_TYPE_COLOKNAGA === bettype ||
                            infoBetType.BET_TYPE_KOMBINASI === bettype ||
                            infoBetType.BET_TYPE_QUICKBUY === bettype ||
                            infoBetType.BET_TYPE_MACAU_SHIO === bettype) &&
                        <td>{value.bet2}</td>
                        }
                        {
                        (
                            infoBetType.BET_TYPE_QUICKBUY === bettype ||
                            infoBetType.BET_TYPE_COLOKNAGA === bettype) &&
                        <td>{value.bet3}</td>
                        }
                        {
                        (
                            infoBetType.BET_TYPE_QUICKBUY === bettype ||
                            infoBetType.BET_TYPE_COLOKJITU === bettype) &&
                        <td>{value.posisi}</td>
                        }
                        <td>{formatPricewithdecimal(value.amount)}</td>
                        <td>{
                            (getGameType === "4d3d2d") ? (
                                bettype > 1000 ? 0
                                : value.info == "4D" ? betDicountData.showDisc4d 
                                : (value.info == "3D Belakang" || value.info == "3D  Depan") 
                                ? betDicountData.showDisc3d 
                                :  (value.info == "2D Belakang" || value.info == "2D  Depan" || value.info == "2D  Tengah")  ? betDicountData.showDisc2d : betDicountData.showDisc
                            )
                            :
                            getGameType === "quickbuy" ? (
                                value.info == "4D" ? betDicountData.showDisc4d 
                                : (value.info == "3D Belakang" || value.info == "3D  Depan") ? betDicountData.showDisc3d 
                                : (value.info == "2D Belakang" || value.info == "2D  Depan" || value.info == "2D  Tengah")  ? betDicountData.showDisc2d
                                : value.info == "Bebas" ? betDicountData.showDiscColokBebas
                                : value.info == "Bebas 2D" ? betDicountData.showDiscColokBebas2d
                                : value.info == "Naga" ? betDicountData.showDiscColokNaga
                                : value.info == "Colok Jitu" ? betDicountData.showDiscColokJitu
                                : value.info == "Shio" ? betDicountData.showDiscShio
                                : value.info == "Kombinasi" ? betDicountData.showDiscKombinasi
                                : value.info == "50-50" ? betDicountData.showDisc5050
                                : value.info == "50-50 2D" ? betDicountData.showDisc50502d
                                : value.info == "Tengah Tepi" ? betDicountData.showDiscTengahTepi
                                : betDicountData.showDiscSilangHomo
                            )
                            : getGameType === "5D6D" ? (
                                value.info == "5D6D" ? betDicountData.showDisc6d 
                                : betDicountData.showDisc5d
                            )
                            : betDicountData.showDisc
                        }</td>
                        <td>{
                            getGameType === "4d3d2d" ? (
                                value.info == "4D" ? betDicountData.showMenang4d 
                                : value.info == "3D Belakang" ? betDicountData.showMenang3dBelakang
                                    : value.info == "3D  Depan" ? betDicountData.showMenang3dDepan
                                        : value.info == "2D Belakang" ? betDicountData.showMenang2dBelakang
                                            : value.info == "2D  Depan" ? betDicountData.showMenang2dDepan
                                                : value.info == "2D  Tengah"  ? betDicountData.showMenang2dTengah
                                                    : betDicountData.showMenang4d
                            )
                            : getGameType === "quickbuy" ? (
                                value.info == "4D" ? betDicountData.showMenang4d
                                : (value.info == "3D Belakang" || value.info == "3D  Depan") ? betDicountData.showMenang3d 
                                : value.info == "2D Belakang" ? betDicountData.showMenang2dBelakang
                                : value.info == "2D  Depan" ? betDicountData.showMenang2dDepan
                                : value.info == "2D  Tengah"  ? betDicountData.showMenang2dTengah
                                : value.info == "Bebas" ? betDicountData.showMenangColokBebas
                                : value.info == "Bebas 2D" ? betDicountData.showMenangColokBebas2d
                                : value.info == "Naga" ? betDicountData.showMenangColokNaga
                                : value.info == "Colok Jitu" ? betDicountData.showMenangColokJitu
                                : value.info == "Shio" ? betDicountData.showMenangShio
                                : value.info == "Kombinasi" ? betDicountData.showMenangKombinasi
                                : value.info == "50-50" ? betDicountData[`showMenang5050_${value.bet.replace(' ', '_')}`]
                                : value.info == "50-50 2D" ? betDicountData[`showMenang50502d_${value.bet}`]
                                : value.info == "Tengah Tepi" ? (value.bet == "tengah" ? betDicountData.showMenangTengah : betDicountData.showMenangTepi)
                                : betDicountData.showMenangHomo_Belakang
                            )
                            : getGameType == "tengahtepi" ? (
                                value.bet == "tengah" ? betDicountData.keitengah : betDicountData.keitepi
                            )
                            : getGameType == "dasar" ? (
                                betDicountData[`kei${value.bet}`]
                            )
                            : (getGameType == "kembangkempis" || getGameType == "silanghomo" || getGameType == "5050") ? ( 
                                betDicountData[`kei_${value.bet.replace(' ', '_')}`]
                            )
                            : getGameType == "50502d" ? (
                                betDicountData[`kei_${value.bet}`]
                            )
                            : getGameType === "5D6D" ? (
                                value.info == "5D6D" ? betDicountData.showMenang6d 
                                : betDicountData.showMenang5d
                            )
                            : betDicountData.showPrize
                        }</td>
                        <td>{formatPricewithdecimal(betAmountPay[index])}</td>
                        <td>{formatPricewithdecimal(getWinAmountPay[index])}</td>
                        <td>{value.info}</td>
                    </tr>
                    )))}
                </tbody>

            </table> : <>

                {transectionDetailData.length == 0 ?
                <div className='invoice_tbl_container'>
                    <p className='no_data'>{props.t("data_not_found")}</p>
                </div>
                : <div className='invoice_tbl_container'>
                    <div style={{color:"white"}}>
                        <input
                            type="checkbox"
                            checked={checkedBoxAll}
                            onClick={(e) => handleSelectOption(e, 'all')}
                        />
                        &nbsp;
                        {props.t("all")}
                    </div>
                    {transectionDetailData.map((value, index) => (
                    <div className='invoice_tbl'>
                        <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                            <input
                                type="checkbox"
                                checked={checkedBoxes[index]}
                                onClick={(e) => handleSelectOption(e, 'row', index)}
                            />
                        </div>
                        <div className='invoice_clmn2'>
                            {period}-{gameCode}
                        </div>
                        </div>
                        <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                            <p>{props.t("bet")}</p>
                        </div>
                        <div className='invoice_clmn2'>
                            {value.bet}
                        </div>
                        </div>
                        {
                        (infoBetType.BET_TYPE_COLOKBEBAS2D === bettype ||
                            infoBetType.BET_TYPE_COLOKNAGA === bettype ||
                            infoBetType.BET_TYPE_KOMBINASI === bettype ||
                            infoBetType.BET_TYPE_QUICKBUY === bettype ||
                            infoBetType.BET_TYPE_MACAU_SHIO === bettype) &&
                        <div className={`invoice_tbl_row `} >
                            <div className='invoice_clmn1'>
                            <p>{props.t("bet")}2</p>
                            </div>
                            <div className='invoice_clmn2'>
                            {value.bet2}
                            </div>
                        </div>
                        }
                        {
                        (
                            infoBetType.BET_TYPE_QUICKBUY === bettype ||
                            infoBetType.BET_TYPE_COLOKNAGA === bettype) &&
                        <div className={`invoice_tbl_row `} >
                            <div className='invoice_clmn1'>
                            <p>{props.t("bet")}3</p>
                            </div>
                            <div className='invoice_clmn2'>
                            {value.bet3}
                            </div>
                        </div>
                        }
                        {
                        (
                            infoBetType.BET_TYPE_QUICKBUY === bettype ||
                            infoBetType.BET_TYPE_COLOKJITU === bettype) &&
                        <div className={`invoice_tbl_row `} >
                            <div className='invoice_clmn1'>
                            <p>{props.t("position")}</p>
                            </div>
                            <div className='invoice_clmn2'>
                            {value.posisi}
                            </div>
                        </div>
                        }
                        <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                            <p>{props.t("amount")}</p>
                        </div>
                        <div className='invoice_clmn2'>
                            {formatPricewithdecimal(value.amount)}
                        </div>
                        </div>
                        <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                            <p>{props.t("discount")} %</p>
                        </div>
                        <div className='invoice_clmn2'>
                            {
                                (getGameType === "4d3d2d") ? (
                                    value.info == "4D" ? betDicountData.showDisc4d 
                                    : (value.info == "3D Belakang" || value.info == "3D  Depan") 
                                    ? betDicountData.showDisc3d 
                                    :  (value.info == "2D Belakang" || value.info == "2D  Depan" || value.info == "2D  Tengah")  ? betDicountData.showDisc2d : betDicountData.showDisc
                                )
                                :
                                getGameType === "quickbuy" ? (
                                    value.info == "4D" ? betDicountData.showDisc4d 
                                    : (value.info == "3D Belakang" || value.info == "3D  Depan") ? betDicountData.showDisc3d 
                                    : (value.info == "2D Belakang" || value.info == "2D  Depan" || value.info == "2D  Tengah")  ? betDicountData.showDisc2d
                                    : value.info == "Bebas" ? betDicountData.showDiscColokBebas
                                    : value.info == "Bebas 2D" ? betDicountData.showDiscColokBebas2d
                                    : value.info == "Naga" ? betDicountData.showDiscColokNaga
                                    : value.info == "Colok Jitu" ? betDicountData.showDiscColokJitu
                                    : value.info == "Shio" ? betDicountData.showDiscShio
                                    : value.info == "Kombinasi" ? betDicountData.showDiscKombinasi
                                    : value.info == "50-50" ? betDicountData.showDisc5050
                                    : value.info == "50-50 2D" ? betDicountData.showDisc50502d
                                    : value.info == "Tengah Tepi" ? betDicountData.showDiscTengahTepi
                                    : betDicountData.showDiscSilangHomo
                                ): getGameType === "5D6D" ? (
                                    value.info == "5D6D" ? betDicountData.showDisc6d 
                                    : betDicountData.showDisc5d
                                )
                                : betDicountData.showDisc
                            }
                        </div>
                        </div>
                        <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                            <p>{infoBetType.BET_TYPE_5050 === bettype ||
                            infoBetType.BET_TYPE_50502D === bettype ||
                            infoBetType.BET_TYPE_TENGAHTEPI === bettype ||
                            infoBetType.BET_TYPE_DASAR === bettype ||
                            infoBetType.BET_TYPE_SILANGHOMO === bettype ||
                            infoBetType.BET_TYPE_KEMBANGKEMPIS === bettype ? `${props.t("kei").charAt(0).toUpperCase() + props.t("kei").slice(1)} %` : props.t("prize")
                            }</p>
                        </div>
                        <div className='invoice_clmn2'>
                            {
                                getGameType === "4d3d2d" ? (
                                    value.info == "4D" ? betDicountData.showMenang4d 
                                    : value.info == "3D Belakang" ? betDicountData.showMenang3dBelakang
                                        : value.info == "3D  Depan" ? betDicountData.showMenang3dDepan
                                            : value.info == "2D Belakang" ? betDicountData.showMenang2dBelakang
                                                : value.info == "2D  Depan" ? betDicountData.showMenang2dDepan
                                                    : value.info == "2D  Tengah"  ? betDicountData.showMenang2dTengah
                                                        : betDicountData.showMenang4d
                                )
                                : getGameType === "quickbuy" ? (
                                    value.info == "4D" ? betDicountData.showMenang4d
                                    : (value.info == "3D Belakang" || value.info == "3D  Depan") ? betDicountData.showMenang3d 
                                    : value.info == "2D Belakang" ? betDicountData.showMenang2dBelakang
                                    : value.info == "2D  Depan" ? betDicountData.showMenang2dDepan
                                    : value.info == "2D  Tengah"  ? betDicountData.showMenang2dTengah
                                    : value.info == "Bebas" ? betDicountData.showMenangColokBebas
                                    : value.info == "Bebas 2D" ? betDicountData.showMenangColokBebas2d
                                    : value.info == "Naga" ? betDicountData.showMenangColokNaga
                                    : value.info == "Colok Jitu" ? betDicountData.showMenangColokJitu
                                    : value.info == "Shio" ? betDicountData.showMenangShio
                                    : value.info == "Kombinasi" ? betDicountData.showMenangKombinasi
                                    : value.info == "50-50" ? betDicountData[`showMenang5050_${value.bet.replace(' ', '_')}`]
                                    : value.info == "50-50 2D" ? betDicountData[`showMenang50502d_${value.bet}`]
                                    : value.info == "Tengah Tepi" ? (value.bet == "tengah" ? betDicountData.showMenangTengah : betDicountData.showMenangTepi)
                                    : betDicountData.showMenangHomo_Belakang
                                )
                                : getGameType == "tengahtepi" ? (
                                    value.bet == "tengah" ? betDicountData.keitengah : betDicountData.keitepi
                                )
                                : getGameType == "dasar" ? (
                                    betDicountData[`kei${value.bet}`]
                                )
                                : (getGameType == "kembangkempis" || getGameType == "silanghomo" || getGameType == "5050") ? ( 
                                    betDicountData[`kei_${value.bet.replace(' ', '_')}`]
                                )
                                : getGameType == "50502d" ? (
                                    betDicountData[`kei_${value.bet}`]
                                )
                                : getGameType === "5D6D" ? (
                                    value.info == "5D6D" ? betDicountData.showMenang6d 
                                    : betDicountData.showMenang5d
                                )
                                : betDicountData.showPrize
                            }
                        </div>
                        </div>
                        <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                            <p>{props.t("total_amount")}</p>
                        </div>
                        <div className='invoice_clmn2'>
                            {formatPricewithdecimal(betAmountPay[index])}
                        </div>
                        </div>
                        <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                            <p>{props.t("x_win")}</p>
                        </div>
                        <div className='invoice_clmn2'>
                            {formatPricewithdecimal(getWinAmountPay[index])}
                        </div>
                        </div>
                        <div className={`invoice_tbl_row `} >
                        <div className='invoice_clmn1'>
                            <p>{props.t("desc")}</p>
                        </div>
                        <div className='invoice_clmn2'>
                            {value.info}
                        </div>
                        </div>
                    </div>
                    ))}

                </div>
                } </>}
            <div className='total_price_div'>
            {props.t("total")}: {formatPricewithdecimal(totalBuyers)}
            </div>
            <div className='total_price_div'>
                <button className='submit-btn' onClick={submitProcess} >
                    {props.t("submit")}
                </button>
            </div>
            {showConfirmationPopup && (
                <ConfirmBetDeskonPopup
                onClose={hanldeConfirmationPopupClose}
                message={null}
                mainContent={succMessage}
                submitProcessOk={submitProcessOk}
                />
            )}
            {showCancelledPopup && (
              <CancelledBetDeskonPopup
                onClose={() => setShowCancelledPopup(false)}
              />
            )}
            {
              showErrorPopup && (
                <ErrorInnerPopup
                  modalTitle={""}
                  modalHeader={true}
                  onCloseModal={() => setShowErrorPopup(false)}
                >
                  <ErrorPopup
                    message={errMessage}
                    onClose={() => (setShowErrorPopup(false))}
                  />
                </ErrorInnerPopup>
              )
            }
            {
              showErrorMarketPopup && (
                <ErrorInnerPopup
                  modalTitle={""}
                  modalHeader={true}
                  onCloseModal={() => setShowErrorMarketPopup(false)}
                >
                  <ErrorPopup
                    message={errMessage}
                    onClose={() => (setShowErrorMarketPopup(false), setReBetShowPopup(false))}
                  />
                </ErrorInnerPopup>
              )
            }
        </div>
        </div>
    )
}

export default withTranslation()(ReBetPopup)